import { useMutation, useQueryClient } from '@tanstack/react-query'

import {
    DeferMinimumGuaranteedCreditLimitRequest,
    DeferMinimumGuaranteedCreditLimitResponse,
} from '@appTypes/EligibilityApi.interface'

import useAppQueryState from '@hooks/useAppQueryState'

import { handleApiResponse } from './utils/handleApiResponse'

export const useMinimumGuaranteedCreditLimitDeferMutation = () => {
    const queryClient = useQueryClient()
    const { appQueryState } = useAppQueryState()

    return useMutation<
        DeferMinimumGuaranteedCreditLimitResponse,
        void,
        DeferMinimumGuaranteedCreditLimitRequest
    >(
        body =>
            fetch(
                `${process.env.NEXT_PUBLIC_BASE_PATH}/api/minimum-guaranteed-credit-limit-defer/`,
                {
                    body: JSON.stringify(body),
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json',
                    },
                }
            ).then(handleApiResponse),
        {
            onSuccess: async data => {
                return await Promise.all([
                    queryClient.setQueryData(
                        [
                            'minimumGuaranteedCreditLimit',
                            appQueryState.customerId,
                        ],
                        data
                    ),
                ])
            },
        }
    )
}
